var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.showToast()}}},[_vm._v("\n        Show Toast\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }